import { TbBus } from "react-icons/tb";
import { HiOutlineMail } from "react-icons/hi";
import { GoSearch } from "react-icons/go";
import { IoIosArrowDown, IoMdCheckmark } from "react-icons/io";
import { FaRegUser } from "react-icons/fa6";
import { BsCart3, BsArrowUpCircleFill } from "react-icons/bs";
import { FaRegHeart, FaArrowRight, FaPlus, FaStar } from "react-icons/fa";
import { IoMenu, IoClose } from "react-icons/io5";
import { PiUserListBold } from "react-icons/pi";
import { CgLogOut } from "react-icons/cg";
import { LiaGiftsSolid } from "react-icons/lia";
import { RiCoupon2Line } from "react-icons/ri";
import { AiOutlineDeliveredProcedure } from "react-icons/ai";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { GiClothes } from "react-icons/gi";

const icons = {
  Bus: TbBus,
  Email: HiOutlineMail,
  Search: GoSearch,
  Down: IoIosArrowDown,
  Up: BsArrowUpCircleFill,
  User: FaRegUser,
  Cart: BsCart3,
  Heart: FaRegHeart,
  ArrowRight: FaArrowRight,
  Mark: IoMdCheckmark,
  Menu: IoMenu,
  Close: IoClose,
  Plus: FaPlus,
  DetailUser: PiUserListBold,
  Logout: CgLogOut,
  Order: LiaGiftsSolid,
  Voucher: RiCoupon2Line,
  Delivered: AiOutlineDeliveredProcedure,
  Star: FaStar,
  Eye: MdOutlineRemoveRedEye,
  Clothes: GiClothes,
};

export default icons;
